import DispatchConstants from 'app/shared/constants/DispatchConstants';
import { assign } from 'lodash';

const initState = () => ({
    contracts: [],
});

const enterpriseSingleFamily = (state = initState(), action = {}) => {
    const { type, payload } = action;

    if (type === DispatchConstants.SINGLE_FAMILY_SET_CONTRACTS) {
        return assign({}, state, payload);
    }

    return state;
};

export default enterpriseSingleFamily;
